import { ImageOff } from 'lucide-react';

import { cn } from '@/lib/utils';

import { SiteImage } from './SiteImage';

/**
 * An ad's thumbnail (http(s) only, no referrer), TP's ad-strip crop (`rounded-sm object-cover object-top`), or a
 * neutral placeholder tile (`bg-ds-ink-a05` + ImageOff, themed in light and dark) when it is missing, unsafe or fails to load.
 * `className` sets the size (default `h-16 w-12`).
 */
export function AdThumb({ src, className = 'h-16 w-12' }: { src: string | null | undefined; className?: string }) {
  return (
    <SiteImage
      src={src}
      className={cn(className, 'shrink-0 rounded-sm object-cover object-top')}
      fallback={
        <span
          aria-hidden="true"
          className={cn(className, 'flex shrink-0 items-center justify-center rounded-sm bg-ds-ink-a05 text-ds-text-3')}
        >
          <ImageOff className="size-4" />
        </span>
      }
    />
  );
}
